// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconNews } from '@tabler/icons';

// constant
const icons = {
    IconNews
};

// ==============================|| BLOG MENU ITEMS ||============================== //

const blog = {
    id: 'blog',
    type: 'group',
    children: [
        {
            id: 'blog-list',
            title: <FormattedMessage id="blog" />,
            type: 'item',
            icon: icons.IconNews,
            url: '/blog/list'
        }
    ]
};

export default blog;
